import React, { useEffect, useState } from 'react';
import { getOrgId } from '../components/ApiConst';
import { TextField } from '@mui/material';
import Logo from "../assets/Images/ellan_log.png";
import LoadingSpinner from '../components/LoaderSmall';

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [orgName, setOrgName] = useState<string>(window.location.pathname.replace('/', ''));
  const [hostName, setHostName] = useState(window.location.host);
  const [showError, setShowError] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const urlParams = new URLSearchParams(window.location.search);
  const keyParam = urlParams.get('key');

const getFun = (id: string, host_name: string) => {
  setLoading(true);
  getOrgId(id, host_name)
    .then((elm: any) => {
      localStorage.setItem("org_id", elm.data.data.instance_id); 
      localStorage.setItem("org_name", id);
      window.location.reload();
    })
    .catch((error: any) => {
      setShowError(error.message || "Something went wrong.");
      setLoading(false);
    });
};


useEffect(() => {
  const savedOrgName = localStorage.getItem("org_name");
  if (savedOrgName) {
    setMessage(savedOrgName);
  }

  if (keyParam) {
    getFun(keyParam, hostName);
  } else if (orgName && orgName !== '') {
    getFun(orgName, hostName);
  }
}, []);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value);
  };

  const handleClick = () => {
    getFun(message, hostName);
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <section className="home_parent">
          <div className="child">
            <div className="logo">
              <img src={Logo} alt="Logo" />
            </div>
            <div className="heading">Please Enter Your Organization Name</div>
            <div>
              <TextField
                type="text"
                id="message"
                name="message"
                label="Name"
                onChange={handleChange}
                value={message}
                variant="outlined"
              />
            </div>
            {showError && (
              <span style={{ fontSize: "12px", color: "red" }}>{showError}</span>
            )}
            <div className="continue-button-div" style={{ marginTop: "20px" }}>
              <button type="button" onClick={handleClick}>Continue</button>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Home;
